import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Select2OptionData } from 'ng2-select2';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
declare var $;
declare var google: any;

@Component({
  selector: 'app-dashboard-geo',
  templateUrl: './dashboard-geo.component.html',
  styleUrls: ['./dashboard-geo.component.css']
})
export class DashboardGeoComponent implements OnInit, OnDestroy {

  filter = {
    clientId: '',
    schoolId: '',
    busIds: [],
    date: new Date()
  };
  staticFilter: any;

  user: any;
  map: any;
  markers: any[] = [];
  markerBounds: any;
  markersData: any = {};
  markersUpdater: any = null;
  mapRequestId: number = 0;

  // Journey overlay on map
  journeyPolyline: any = null;
  journeyMarkers: any[] = [];
  selectedTripId: any = null;
  journeyLoading: boolean = false;

  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  dateTimeFilter = (d: Date): boolean => { return true; };

  // MultiSelect for vehicles
  optionsModelBus: number[] = [];
  multiSelectBus: IMultiSelectOption[] = [];
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block'
  };
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout s\u00e9lectionner',
    uncheckAll: 'Tout d\u00e9selectionner',
    checked: '\u00e9l\u00e9ment s\u00e9lectionn\u00e9',
    checkedPlural: '\u00e9l\u00e9ments s\u00e9lectionn\u00e9s',
    searchPlaceholder: 'Trouver',
    searchEmptyResult: 'Rien n\'a \u00e9t\u00e9 trouv\u00e9...',
    searchNoRenderText: 'Tapez dans la bo\u00eete de recherche pour voir les r\u00e9sultats ...',
    defaultTitle: 'S\u00e9lectionner',
    allSelected: 'Tous s\u00e9lectionn\u00e9s',
  };

  Highcharts: typeof Highcharts = Highcharts;
  chart1Options: {};
  chart2Options: {};

  // Stats
  totalBuses: number = 0;
  activeBuses: number = 0;
  totalTrips: number = 0;
  totalDistance: number = 0;
  totalAlerts: number = 0;
  totalExpenses: number = 0;

  // Data arrays
  trips: any[] = [];
  tripsPage: number = 1;
  tripsPageSize: number = 7;
  perVehicle: any[] = [];
  alerts: any[] = [];

  // Expense breakdown for pie chart
  expenseBreakdown: any = {};

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private zone: NgZone,
    private authService: AuthService,
    private roleService: NgxRolesService
  ) {
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    this.user = this.authService.getUser();

    // Initialize based on user role (same pattern as dashboard-pro)
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      this.filter.clientId = this.user.id;
      this.staticFilter.clientId = this.filter.clientId;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.filter.clientId = this.user.School && this.user.School.Client ? this.user.School.Client.id : '';
      this.filter.schoolId = this.user.School ? this.user.School.id : '';
      this.staticFilter.clientId = this.filter.clientId;
      this.staticFilter.schoolId = this.filter.schoolId;
      this.initBusSelect();
    }
  }

  ngOnInit() {
    this.setupCharts();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    const params = new HttpParams({
      fromObject: {
        clientId: this.staticFilter.clientId
      }
    });
    this.http.get('/api/school/lookup', { params }).subscribe((schools: any[]) => {
      this.filter.schoolId = schools.length ? schools[0].id : '';
      this.schoolsData = schools.map((school) => {
        return {
          id: school.id,
          text: school.name,
          selected: school.id === this.filter.schoolId
        };
      });
      this.initBusSelect();
    });
  }

  initBusSelect() {
    this.optionsModelBus = [];
    const params = new HttpParams({
      fromObject: {
        clientId: this.staticFilter.clientId,
        schoolId: this.filter.schoolId || ''
      }
    });
    this.http.get('/api/bus/lookup', { params }).subscribe((buses: any[]) => {
      this.multiSelectBus = buses.map((bus) => {
        return {
          id: bus.id,
          name: bus.name
        };
      });
      // Select all by default
      this.optionsModelBus = buses.map(bus => bus.id);
      this.filter.busIds = this.optionsModelBus;
      // Update stats
      this.totalBuses = buses.length;
      this.onFilter();
    });
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.staticFilter.clientId = e.value;
    this.filter.schoolId = '';
    this.filter.busIds = [];
    this.optionsModelBus = [];
    this.initSchoolSelect();
  }

  onFilter() {
    // Sync multiselect model with filter
    this.filter.busIds = this.optionsModelBus;
    this.fetchDashboardData();
  }

  get pagedTrips(): any[] {
    const start = (this.tripsPage - 1) * this.tripsPageSize;
    return this.trips.slice(start, start + this.tripsPageSize);
  }

  get tripsTotalPages(): number {
    return Math.ceil(this.trips.length / this.tripsPageSize) || 1;
  }

  tripsGoToPage(page: number) {
    if (page >= 1 && page <= this.tripsTotalPages) {
      this.tripsPage = page;
    }
  }

  formatDuration(minutes: number): string {
    if (!minutes && minutes !== 0) { return '-'; }
    if (minutes >= 60) {
      const h = Math.floor(minutes / 60);
      const m = minutes % 60;
      return m > 0 ? h + 'h' + (m < 10 ? '0' : '') + m + 'min' : h + 'h';
    }
    return minutes + ' min';
  }

  fetchDashboardData() {
    const date = moment(this.filter.date).format('YYYY-MM-DD');
    const busIds = this.filter.busIds || [];

    // Init map with selected vehicles
    this.initMap();

    // Fetch trip data from rapport_trajets via geoDashboard endpoint
    if (busIds.length > 0) {
      const activityParams = new HttpParams()
        .set('schoolId', this.filter.schoolId)
        .set('busIds', JSON.stringify(busIds))
        .set('date', date);
      this.http.get('/api/activityReport/geoDashboard', { params: activityParams }).subscribe((data: any) => {
        this.totalTrips = data.totalTrips || 0;
        this.totalDistance = data.totalDistance || 0;
        this.trips = data.trips || [];
        this.tripsPage = 1;
        this.perVehicle = data.perVehicle || [];
        this.updateChart1();
      });
    } else {
      this.totalTrips = 0;
      this.totalDistance = 0;
      this.trips = [];
      this.perVehicle = [];
      this.updateChart1();
    }

    // Fetch alerts of the day - POST /api/busEvent/ with body.filter
    const eventFilter = {
      filter: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId,
        busIds: busIds,
        alertId: '',
        isAdmin: false,
        dateTimeInterval: [
          date + ' 00:00',
          date + ' 23:59'
        ]
      },
      start: 0,
      length: 50
    };
    this.http.post('/api/busEvent/', eventFilter).subscribe((data: any) => {
      this.alerts = data.data || [];
      this.totalAlerts = data.recordsTotal || 0;
    });

    // Fetch expenses for the selected date's month
    const monthStart = moment(this.filter.date).startOf('month').format('YYYY-MM-DD');
    const monthEnd = moment(this.filter.date).endOf('month').format('YYYY-MM-DD');
    const expenseFilter = {
      filter: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId,
        busId: '',
        type: '',
        title: '',
        dateInterval: [monthStart, monthEnd]
      },
      start: 0,
      length: 1000
    };
    this.http.post('/api/depenses/', expenseFilter).subscribe((data: any) => {
      const expenses = data.data || [];
      this.totalExpenses = 0;
      this.expenseBreakdown = {
        Gazoil: 0,
        Assurance: 0,
        Vidange: 0,
        VisteT: 0,
        Reparation: 0,
        Autre: 0
      };
      expenses.forEach((exp) => {
        const price = parseFloat(exp.price) || 0;
        this.totalExpenses += price;
        if (this.expenseBreakdown.hasOwnProperty(exp.type)) {
          this.expenseBreakdown[exp.type] += price;
        } else {
          this.expenseBreakdown['Autre'] += price;
        }
      });
      this.updateChart2();
    });
  }

  initMap() {
    const mapEl = document.getElementById('geo-dashboard-map');
    if (!mapEl || typeof google === 'undefined') {
      return;
    }

    if (!this.map) {
      const mapOptions = {
        center: { lat: 33.5731, lng: -7.5898 },
        zoom: 7,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      this.map = new google.maps.Map(mapEl, mapOptions);
    }
    this.markerBounds = new google.maps.LatLngBounds();

    this.loadBusPositions();
  }

  loadBusPositions() {
    if (!this.filter.schoolId) {
      return;
    }

    const selectedBusIds = this.filter.busIds || [];
    if (selectedBusIds.length === 0) {
      return;
    }

    // Clear previous markers and clusterer
    this.clearMapMarkers();
    clearInterval(this.markersUpdater);

    // Increment request ID to ignore stale responses
    this.mapRequestId++;
    const currentRequestId = this.mapRequestId;

    const params = new HttpParams()
      .set('schoolId', this.filter.schoolId)
      .set('busIds', JSON.stringify(selectedBusIds));

    this.http.get('/api/bus/map', { params }).subscribe((data: any) => {
      // Ignore response if a newer request was made
      if (currentRequestId !== this.mapRequestId) { return; }
      if (data.hasOwnProperty('buses')) {
        this.clearMapMarkers();
        this.markerBounds = new google.maps.LatLngBounds();
        this.addMarkers(data.buses);
        if (this.markers.length > 0) {
          this.map.fitBounds(this.markerBounds);
        }
        // Auto-refresh every 10s
        this.markersUpdater = setInterval(() => { this.updateMarkers(params); }, 10 * 1000);
      }
    });
  }

  clearMapMarkers() {
    this.markers.forEach(m => {
      m.setMap(null);
    });
    this.markers = [];
    // Close all info windows
    Object.keys(this.markersData).forEach(key => {
      if (this.markersData[key].infoWindow) {
        this.markersData[key].infoWindow.close();
      }
    });
    this.markersData = {};
  }

  addMarkers(buses: any[]) {
    this.activeBuses = 0;
    for (let i = 0; i < buses.length; i++) {
      this.addMarker(buses[i]);
    }
  }

  addMarker(bus: any) {
    if (!bus.lat || !bus.lng) {
      return;
    }
    this.activeBuses++;
    const pos = new google.maps.LatLng(bus.lat, bus.lng);

    // Icon based on iconeName, angle, alertMouvement (same logic as bus-map)
    let icon;
    if (bus.iconeName === 'Colis' || bus.iconeName === 'Ruche' || bus.iconeName === 'Velo-Taxi') {
      icon = 'assets/images/markers/' + bus.iconeName + '/' + bus.iconeName + '-marker.png';
    } else if (bus.iconeName === 'Bus') {
      icon = 'assets/images/markers/Bus/Bus-marker_' + bus.angle + '.PNG';
    } else if (bus.iconeName === 'Ambulance') {
      icon = 'assets/images/markers/Ambulance/Ambulance-marker_' + bus.angle + '.png';
    } else if (bus.alertMouvement === 0) {
      icon = 'assets/images/markers/' + bus.iconeName + '-stop/' + bus.iconeName + '-marker_' + bus.angle + '.png';
    } else if (bus.alertMouvement === 1) {
      icon = 'assets/images/markers/' + bus.iconeName + '-move/' + bus.iconeName + '-marker_' + bus.angle + '.png';
    }

    // InfoWindow content with movement color
    let contentInfoWindow;
    if (bus.alertMouvement === 1) {
      contentInfoWindow = `<div style="color: #00BF63; padding: 7px; display: flex; align-items: center; font-family: 'Roboto', sans-serif; font-size: 10px;"><b><p>${bus.name}</p></b></div>`;
    } else {
      contentInfoWindow = `<div style="color: #FF3131; padding: 7px; display: flex; align-items: center; font-family: 'Roboto', sans-serif; font-size: 10px;"><b><p>${bus.name}</p></b></div>`;
    }

    const infoWindow = new google.maps.InfoWindow({ content: contentInfoWindow, disableAutoPan: true });

    const marker = new google.maps.Marker({
      position: pos,
      map: this.map,
      icon: icon
    });

    this.markerBounds.extend(pos);
    infoWindow.open(this.map, marker);

    // Hide close button on info window
    infoWindow.addListener('domready', () => {
      $('.gm-style-iw').parent().find('button').removeAttr('style').hide();
      $('.gm-style-iw').css({ padding: '0' });
      $('.gm-style .gm-style-iw-d').css('overflow', 'visible');
    });

    this.markers.push(marker);
    this.markersData[bus.id] = { bus: bus, marker: marker, infoWindow: infoWindow, isDetailedInfoVisible: false };

    marker.addListener('click', () => {
      const md = this.markersData[bus.id];
      if (md.isDetailedInfoVisible) {
        md.infoWindow.setContent(contentInfoWindow);
      } else {
        this.openInfoWindow(bus.id);
      }
      md.isDetailedInfoVisible = !md.isDetailedInfoVisible;
    });
  }

  openInfoWindow(busId) {
    if (this.markersData.hasOwnProperty(busId)) {
      const b = this.markersData[busId].bus;
      const position = b.lat + ',' + b.lng;
      let content = `<b>Véhicule :</b> ${b.name}<br>
        <b>Moteur :</b> ${b.alertMouvement === 1 ? '<label style="color:#00BF63">Démarrer</label>' : '<label style="color:#FF3131">Arrêter</label>'}<br>
        <b>Date :</b> ${moment.utc(b.time).format('DD/MM/YYYY à HH:mm:ss')}<br>
        <b>Position :</b> ${position}<br>
        <b>Vitesse :</b> ${b.speed} km/h<br>
        <b>Kilométrage :</b> ${b.mileage} km<br>
        <b>Signal GSM :</b> ${b.gsmSignalStrength}/5<br>
        <b>État :</b> ${b.busStatus === 'not connected' ? '<label style="color:orange">Déconnecté</label>' : '<label style="color:#00BF63">Connecté</label>'}`;
      content = '<div style="padding: 10px;">' + content + '</div>';
      this.markersData[busId].infoWindow.setContent(content);
      this.markersData[busId].infoWindow.open(this.map, this.markersData[busId].marker);
    }
  }

  updateMarkers(params: HttpParams) {
    this.http.get('/api/bus/map', { params }).subscribe((data: any) => {
      if (!data.buses) { return; }
      data.buses.forEach((bus: any) => {
        if (this.markersData.hasOwnProperty(bus.id)) {
          this.markersData[bus.id].bus = bus;
          const pos = { lat: bus.lat, lng: bus.lng };
          this.markersData[bus.id].marker.setPosition(pos);

          let icon;
          if (bus.iconeName === 'Colis' || bus.iconeName === 'Ruche' || bus.iconeName === 'Velo-Taxi') {
            icon = 'assets/images/markers/' + bus.iconeName + '/' + bus.iconeName + '-marker.png';
          } else if (bus.iconeName === 'Bus') {
            icon = 'assets/images/markers/Bus/Bus-marker_' + bus.angle + '.PNG';
          } else if (bus.iconeName === 'Ambulance') {
            icon = 'assets/images/markers/Ambulance/Ambulance-marker_' + bus.angle + '.png';
          } else if (bus.alertMouvement === 0) {
            icon = 'assets/images/markers/' + bus.iconeName + '-stop/' + bus.iconeName + '-marker_' + bus.angle + '.png';
          } else if (bus.alertMouvement === 1) {
            icon = 'assets/images/markers/' + bus.iconeName + '-move/' + bus.iconeName + '-marker_' + bus.angle + '.png';
          }
          this.markersData[bus.id].marker.setIcon(icon);

          let contentInfoWindow;
          if (bus.alertMouvement === 1) {
            contentInfoWindow = `<div style="color: #00BF63; padding: 7px; display: flex; align-items: center; font-family: 'Roboto', sans-serif; font-size: 10px;"><b><p>${bus.name}</p></b></div>`;
          } else {
            contentInfoWindow = `<div style="color: #FF3131; padding: 7px; display: flex; align-items: center; font-family: 'Roboto', sans-serif; font-size: 10px;"><b><p>${bus.name}</p></b></div>`;
          }
          this.markersData[bus.id].infoWindow.setContent(contentInfoWindow);

          if (this.markersData[bus.id].isDetailedInfoVisible) {
            this.markersData[bus.id].infoWindow.close();
            this.openInfoWindow(bus.id);
          }
        }
      });
    });
  }

  updateChart1() {
    const categories = this.perVehicle.map(v => v.busName);
    const data = this.perVehicle.map(v => v.totalDistance);
    this.chart1Options = {
      chart: { type: 'column', backgroundColor: 'rgba(255, 255, 255, 0.0)' },
      title: { text: '' },
      xAxis: { categories: categories, crosshair: true },
      yAxis: { min: 0, title: { text: 'Kilomètres' } },
      legend: { enabled: false },
      series: [{ name: 'KM', data: data, color: '#F7941D' }]
    };
  }

  updateChart2() {
    const typeLabels = {
      Gazoil: 'Gazoil',
      Assurance: 'Assurance',
      Vidange: 'Vidange',
      VisteT: 'Visite Technique',
      Reparation: 'Réparation',
      Autre: 'Autre'
    };
    const typeColors = {
      Gazoil: '#FF9800',
      Assurance: '#2196F3',
      Vidange: '#4CAF50',
      VisteT: '#9C27B0',
      Reparation: '#F44336',
      Autre: '#607D8B'
    };
    const pieData = [];
    Object.keys(this.expenseBreakdown).forEach(type => {
      if (this.expenseBreakdown[type] > 0) {
        pieData.push({
          name: typeLabels[type] || type,
          y: this.expenseBreakdown[type],
          color: typeColors[type] || '#999'
        });
      }
    });
    this.chart2Options = {
      chart: { type: 'pie', backgroundColor: 'rgba(255, 255, 255, 0.0)' },
      title: { text: '' },
      tooltip: { pointFormat: '{series.name}: <b>{point.y:.0f} MAD</b> ({point.percentage:.1f}%)' },
      plotOptions: { pie: { allowPointSelect: true, cursor: 'pointer', dataLabels: { enabled: true, format: '<b>{point.name}</b>: {point.percentage:.1f}%' } } },
      series: [{ name: 'Dépenses', data: pieData }]
    };
  }

  setupCharts() {
    this.updateChart1();
    this.updateChart2();
  }

  // Show trip journey on the map
  showTripJourney(trip: any) {
    this.clearJourneyOverlay();
    this.selectedTripId = trip.id;
    this.journeyLoading = true;

    const date = moment(this.filter.date).format('YYYY-MM-DD');

    const params = new HttpParams()
      .set('schoolId', this.filter.schoolId)
      .set('busIds', JSON.stringify([trip.busId]))
      .set('date', date)
      .set('timeInterval', JSON.stringify([
        moment.unix(trip.startTime).format('YYYY-MM-DD HH:mm:ss'),
        moment.unix(trip.endTime).format('YYYY-MM-DD HH:mm:ss')
      ]));

    this.http.get('/api/bus/mapJourney', { params }).subscribe((data: any) => {
      this.journeyLoading = false;
      if (!data.positions || !data.positions.length) { return; }

      const positions = data.positions;
      const path = [];
      const bounds = new google.maps.LatLngBounds();

      for (let i = 0; i < positions.length; i++) {
        const pos = new google.maps.LatLng(parseFloat(positions[i].lat), parseFloat(positions[i].lng));
        path.push(pos);
        bounds.extend(pos);

        // Start marker
        if (i === 0) {
          const startMarker = new google.maps.Marker({
            position: pos,
            map: this.map,
            label: { text: 'D', color: '#fff', fontWeight: 'bold' },
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 10,
              fillColor: '#4CAF50',
              fillOpacity: 1,
              strokeColor: '#fff',
              strokeWeight: 2
            }
          });
          const startInfo = new google.maps.InfoWindow({
            content: `<div style="padding:8px;">
              <b>Départ</b><br>
              <b>Véhicule :</b> ${trip.busName}<br>
              <b>Heure :</b> ${moment(trip.startTime * 1000).format('HH:mm')}<br>
              <b>Distance :</b> ${trip.distance} km<br>
              <b>Durée :</b> ${this.formatDuration(trip.duration)}
            </div>`
          });
          startMarker.addListener('click', () => { startInfo.open(this.map, startMarker); });
          this.journeyMarkers.push(startMarker);
        }
        // End marker
        if (i === positions.length - 1) {
          const endMarker = new google.maps.Marker({
            position: pos,
            map: this.map,
            label: { text: 'A', color: '#fff', fontWeight: 'bold' },
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 10,
              fillColor: '#F44336',
              fillOpacity: 1,
              strokeColor: '#fff',
              strokeWeight: 2
            }
          });
          const endInfo = new google.maps.InfoWindow({
            content: `<div style="padding:8px;">
              <b>Arrivée</b><br>
              <b>Véhicule :</b> ${trip.busName}<br>
              <b>Heure :</b> ${moment(trip.endTime * 1000).format('HH:mm')}<br>
              <b>Distance :</b> ${trip.distance} km<br>
              <b>Durée :</b> ${this.formatDuration(trip.duration)}
            </div>`
          });
          endMarker.addListener('click', () => { endInfo.open(this.map, endMarker); });
          this.journeyMarkers.push(endMarker);
        }
      }

      // Draw polyline
      this.journeyPolyline = new google.maps.Polyline({
        path: path,
        geodesic: true,
        strokeColor: '#F7941D',
        strokeOpacity: 0.9,
        strokeWeight: 4
      });
      this.journeyPolyline.setMap(this.map);

      // Fit map to journey bounds
      this.map.fitBounds(bounds);
    });
  }

  // Clear journey overlay from the map
  clearJourneyOverlay() {
    if (this.journeyPolyline) {
      this.journeyPolyline.setMap(null);
      this.journeyPolyline = null;
    }
    this.journeyMarkers.forEach(m => m.setMap(null));
    this.journeyMarkers = [];
    this.selectedTripId = null;
  }

  ngOnDestroy(): void {
    clearInterval(this.markersUpdater);
    this.clearMapMarkers();
    this.clearJourneyOverlay();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard-geo/dashboard-geo.component.ts